import { DEFAULT_VIDEO_ASPECT_RATIO, VERTICAL_ASPECT_RATIO_THRESHOLD } from '../_context/constants';

export function isVerticalAspectRatio(aspectRatio: number | undefined): boolean {
    return (aspectRatio || DEFAULT_VIDEO_ASPECT_RATIO) <= VERTICAL_ASPECT_RATIO_THRESHOLD;
}
